<div class="automatic-measure-header" (click)="onSortClick()">
  <div class="automatic-measure-header-row">
    <span class="automatic-measure-label">{{ label }}</span>
    <span
      class="ag-header-icon ag-header-cell-filter-button"
      [class.ag-filter-active]="isFilterActive"
      (click)="onFilterClick($event)">
      <span class="ag-icon ag-icon-filter" role="presentation"></span>
    </span>
    @if (isFilterActive) {
      <span class="filter-clear-btn" role="button" (click)="onClearFilter($event)">
        <span class="ag-icon ag-icon-cross" role="presentation"></span>
      </span>
    }
  </div>
  <div class="automatic-measure-meta">
    @if (unit) {
      <span class="automatic-measure-unit">[{{ unit }}]</span>
    }
    @if (sortDirection) {
      <span
        class="sort-indicator ag-icon"
        [class.ag-icon-asc]="sortDirection === 'asc'"
        [class.ag-icon-desc]="sortDirection === 'desc'"></span>
    }
  </div>
</div>
